import { render, staticRenderFns } from "./mvAddFamilyModal.vue?vue&type=template&id=19fff022&scoped=true"
import script from "./mvAddFamilyModal.vue?vue&type=script&lang=js"
export * from "./mvAddFamilyModal.vue?vue&type=script&lang=js"
import style0 from "./mvAddFamilyModal.vue?vue&type=style&index=0&id=19fff022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fff022",
  null
  
)

export default component.exports